import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { of } from 'rxjs';
import { TerminalsApiService } from './services/terminals-api.service';

@Injectable()
export class ConsignmentResolver implements Resolve<any> {
  constructor(
    private terminalsApiService: TerminalsApiService,
  ) { }

  resolve(activatedRoute: ActivatedRouteSnapshot) {
    if (activatedRoute.params && activatedRoute.params.terminalId) {
      const id = activatedRoute.params?.terminalId as string;
      this.terminalsApiService.setCurrentTerminal(id);
    } else {
      this.terminalsApiService.setCurrentTerminal(undefined);
    }
    return of(activatedRoute.params);
  }
}
